import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import chartPie from '@/components/charts/chartPie/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  props: {
    lang: {
      type: Object,
      required: true,
    },
    managerList: {
      type: Array,
      default () {
        return [];
      },
    },
  },
  mixins: [
    helpers.random_color,
    helpers.work_with_date,
  ],
  components: {
    Multiselect,
    DatePicker,
    chartPie,
    preloader,
    empty,
  },
  data () {
    return {
      qaReports: [],
      qaReportsGraphs: [],

      textCategoryList: [],

      params: {
        source_language: '',
        target_language: '',
        created_on: '',
        type: 'lang',
        doc_type: '',
        manager: '',
      },

      activeTab: 'lang',
      load: true,
    };
  },
  watch: {
    'params.created_on' () {
      this.getSuccessfulReports();
    },
  },
  created () {
    this.getTextCategoryList();
    this.getSuccessfulReports();
  },
  methods: {

    /**
         * Method return string for multiselect
         *
         * @param {Number} count
         */
    limitText (count) {
      return `and ${count} others manager`;
    },

    getTextCategoryList () {
      Api.dashboard
        .getDocType()
        .then((data) => {
          if (data.data.Status) {
            this.textCategoryList = data.data.Data;

            this.textCategoryList.unshift({
              ID: '',
              Name: 'All',
            });
          }
        });
    },

    refreshData () {
      this.load = true;
      this.qaReports = [];
      this.qaReportsGraphs = [];
    },

    changeTab (tab) {
      this.params = {
        source_language: '',
        target_language: '',
        created_on: '',
        type: 'lang',
        doc_type: '',
        manager: '',
      };

      this.activeTab = tab;
      this.params.type = tab;
      this.getSuccessfulReports();
    },

    selectItem (type, event) {
      this.params[type] = event;
      this.getSuccessfulReports();
    },

    removeItem (type) {
      this.params[type] = '';
      this.getSuccessfulReports();
    },

    getSuccessfulReports () {
      this.refreshData();

      Api.dashboard.main
        .getSuccessful(this.transformParams())
        .then((data) => {
          if (data.data.Status) {
            this.qaReports = data.data.Data;

            this.qaReports.forEach((el, index) => {
              const color = this.generateColor();
              el.color = color;

              if (this.activeTab == 'lang') {
                this.qaReportsGraphs.push({
                  name: `${el.SuccessfullyPercentage}%`,
                  y: el.SuccessfullyPercentage,
                  language: {
                    SourceLanguage: el.SourceLanguageData.LanguageName,
                    TargetLanguage: el.TargetLanguageData.LanguageName,
                    taskRating: `${el.SuccessfullyPercentage}%`,
                  },
                  color: color,
                });
              } else {
                this.qaReportsGraphs.push({
                  name: el.TextCategoryName + ` ${el.SuccessfullyPercentage}%`,
                  y: el.SuccessfullyPercentage,
                  docs: {
                    name: el.TextCategoryName,
                    rating: `${el.SuccessfullyPercentage}%`,
                  },
                  color: color,
                });
              }
            });
          }
          this.load = false;
        });
    },

    transformParams () {
      const params = {
        source_language: this.params.source_language != '' ? this.params.source_language.ID : '',
        target_language: this.params.target_language != '' ? this.params.target_language.ID : '',
        created_on: this.convertDatePickerInUnix(this.params.created_on),
        type: this.activeTab,
        doc_type: this.params.doc_type != '' ? this.params.doc_type.ID : '',
        manager: this.params.manager ? this.params.manager.ID : '',
      };

      return params;
    },
  },
};
